
/*

poornima 09/22/2022 2700780638 Fixed global field group and role management sort issue
sohel    10/01/2022 2700780638 Global Field ->Download Configuration-> handle Error Toast Msg and Catagory Payload Changes

*/

import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {GLOBAL_FIELD} from '../../../constants/MicroServiceConstants';
import download from '../../../util/DownloadLink';

const initialData = {
  globalFieldGroupStatus: {},
  dropDownData: {},
  groupCodeData: {},
  getGroupCodeData: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  GlobalFieldListPrintStatus: null,
};

const slice = createSlice({
  name: 'globalFieldGroup',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postGlobalFieldGroupData: (state, action) => {
      state.globalFieldGroupStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    getDetailsByGroupCodeData: (state, action) => {
      state.codeStatus = action.payload.status;
      state.groupCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getDetailsOfGroupCodeData: (state, action) => {
      state.codeStatus = action.payload;
      state.getGroupCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetStatus: (state) => {
      state.globalFieldGroupStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.ruleGroupPrintStatus = null;
    },
    resetCode: (state, action) => {
      state.errorMsg = null;
      state.isLoading = false;
      state.getGroupCodeData = {};
      state.codeStatus = null;
    },
    setGlobalFieldGroupPrintData: (state, action) => {
      state.GlobalFieldListPrintStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchError,
  postGlobalFieldGroupData,
  resetMsg,
  resetStatus,
  resetCode,
  getDetailsByGroupCodeData,
  getDetailsOfGroupCodeData,
  setGlobalFieldGroupPrintData,
} = slice.actions;

export const postGlobalFieldGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${GLOBAL_FIELD}/update/globalfieldgroup`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postGlobalFieldGroupData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const printGlobalFieldGroup = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`globalfield/print/globalfieldgroup`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintGlobalFieldGroup({dockey: data?.message}, data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postPrintGlobalFieldGroup = (payload, postRuleGroupData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`globalfield/generateurlprintglobalfieldGroup`, payload)
      .then((data) => {
        if (data && data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(setGlobalFieldGroupPrintData(postRuleGroupData));
          download(data.data);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const getDetailsByGroupCode = ({groupCode}) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${GLOBAL_FIELD}/find/globalfield/${groupCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getDetailsByGroupCodeData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchDetailsOfGroupCode = (groupCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${GLOBAL_FIELD}/get/globalfields/${groupCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getDetailsOfGroupCodeData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetGlobalFieldGroupStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};

export const restGroupCode = () => {
  return (dispatch) => {
    dispatch(resetCode());
  };
};
